import React from 'react';
import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import { ManageAccounts } from '@mui/icons-material';
import { Box, Grid } from '@mui/material';
import CustomSubmitButton from '../../../components/Forms/CustomSubmitButton';
import CustomTextField from '../../../components/Forms/CustomTextField';
import { useDispatch } from 'react-redux';
import useRTK from '../../../hooks/useRTK';
import { useUpdateORGPhoneMutation } from '../../../api/profile/profileAPI';
import { setUserProfile } from '../../../states/features/profile/profileSlice';

// ################## VALIDATION ####################
// * -> phone
const phoneValidationSchema = Yup.object({
    phone_number: Yup.string()
        .required('Organization phone is required field')
        .nullable()
        .max(10, 'phone number must be at most 10 characters')
        .min(10, 'phone number must be at least 10 characters'),
});

// !############## MAIN FUNC ################
const UpdatePhone = ({ user, closeDialogy, refetchProfile }) => {
    // ################# CONST ##################
    const RTK = useRTK();
    const dispatch = useDispatch();

    // ############### RTK #####################
    const [
        updateORGPhone,
        { isLoading, isSuccess, isError, error, data: updatedData },
    ] = useUpdateORGPhoneMutation();

    // ############### useEffect ################
    // => RTK action
    const rtkActions = (data) => {
        closeDialogy();
        refetchProfile();
        dispatch(setUserProfile(data));
    };
    RTK.useRTKResponse(isSuccess, isError, error, updatedData, rtkActions);

    return (
        <>
            <Formik
                initialValues={{
                    phone_number: user.phone_number
                        ? 0 + user.phone_number.substring(3)
                        : '',
                }}
                validationSchema={phoneValidationSchema}
                onSubmit={(payload) => {
                    updateORGPhone(payload);
                }}
            >
                {(formik) => (
                    <Form>
                        <Grid container justifyContent={'center'}>
                            <Grid item sm={12} xs={12} padding={1}>
                                <CustomTextField
                                    name="phone_number"
                                    className="form-input"
                                    label={`${user.organization_type.name} phone number`}
                                    type="text"
                                />
                            </Grid>
                            <Grid item sm={12} xs={12}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    <CustomSubmitButton
                                        startIcon={<ManageAccounts />}
                                        onClick={formik.handleSubmit}
                                        loading={isLoading}
                                    >
                                        Update phone
                                    </CustomSubmitButton>
                                </Box>
                            </Grid>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </>
    );
};

export default UpdatePhone;
